export enum StatusKYCStepOne {
  REJECTED_BY_WEBSITE = 'REJECTED_BY_WEBSITE',
  REJECTED_BY_INDUSTRY = 'REJECTED_BY_INDUSTRY',
  MISSING_VALIDATION = 'MISSING_VALIDATION',
  RETRY_VALIDATION = 'RETRY_VALIDATION',
  ERROR_VALIDATION = 'ERROR_VALIDATION',
  COMPLETED = 'COMPLETED',
  ENABLED = 'ENABLED',
}
